import React from "react";

import "css/WhiteInteriorPopup.css";

const WhiteInteriorPopup = () => {
    return (
        <div className="WhiteInteriorPopup">
            <h3>White interior frame</h3>
            <p>This exterior finish is available with an optional white internal frame colour for a lighter brighter interior.</p>
        </div>
    );
};

export default WhiteInteriorPopup;



// WEBPACK FOOTER //
// ./src/components/WhiteInteriorPopup.js